module.exports = __webpack_public_path__ + "img/credit-card.729bc543.svg";